import { useState } from "react"
import { toInputFieldDateTimeString,dateRange, toTimeString, toDateString } from "../../utilities/dateUtilities"
import { TimeRangeSlider } from "../shared/timeRangeSlider"
import stringHelpers from "../../utilities/stringHelpers"
import { DateTimePickerWithCustomDisplay } from "../shared/dateTimePickerCustomDisplay"
import { MinutesInputWithUnit } from "../shared/minutesInputWithUnit"

export const AllowListDateTimeForm = ({ startDate, setStartDate, endDate, setEndDate, validOnlyOnSpecificDays, setValidOnlyOnSpecificDays, validOnlyAtSpecificTimes, setValidOnlyAtSpecificTimes, isValidMonday, setIsValidMonday, isValidTuesday, setIsValidTuesday, isValidWednesday, setIsValidWednesday, isValidThursday, setIsValidThursday, isValidFriday, setIsValidFriday, isValidSaturday, setIsValidSaturday, isValidSunday, setIsValidSunday, enabledFromTime, setEnabledFromTime, enabledToTime, setEnabledToTime, areDatesRequired, maxStayMinutes, setMaxStayMinutes, noReturnWithinMinutes, setNoReturnWithinMinutes }) => {

    const { firstDate, lastDate } = dateRange("currentDay")

    const isCurrentDayRange =
        !stringHelpers.isNullOrEmpty(startDate) &&
        !stringHelpers.isNullOrEmpty(endDate) &&
        toInputFieldDateTimeString(startDate) === toInputFieldDateTimeString(firstDate) &&
        toInputFieldDateTimeString(endDate) === toInputFieldDateTimeString(lastDate)

    const [typeDateTime, setTypeDateTime] = useState(
        isCurrentDayRange
        ? "1"
        : (!stringHelpers.isNullOrEmpty(startDate) || !stringHelpers.isNullOrEmpty(endDate) || validOnlyOnSpecificDays || validOnlyAtSpecificTimes || areDatesRequired)
            ? "2"
            : "0"
    )

    return (
        <div className="mandatory-date-time">
            <div>
                <div className="row mb-3">
                    <div className="col-md-3 col-12 ">
                        <h6 className="mb-3 fs-1">Date/Time Details</h6>
                    </div>
                    {!areDatesRequired &&
                        <div className="col-md-6 col-12">
                        <div className="d-flex align-items-center mb-1">
                            <input checked={typeDateTime==="0"} id={"0"} onChange={()=>{
                                setTypeDateTime("0")
                                setStartDate("")
                                setEndDate("")
                            }} className='mr-2' name="type-date-time-selection-radio" key={"0"} value={"0"}
                                   type='radio'/>
                            <label className='m-0' htmlFor={"0"}>Indefinite (no start/end date)</label>
                        </div>

                        <div className="d-flex mb-1 align-items-start">
                            <input checked={typeDateTime==="1"} id={"1"} onChange={()=>{
                                setTypeDateTime("1")
                                setStartDate(toInputFieldDateTimeString(firstDate))
                                setEndDate(toInputFieldDateTimeString(lastDate))
                            }} className='mr-2 mt-1' name="type-date-time-selection-radio" key={"1"} value={"1"}
                                   type='radio'/>
                            <div className="">
                                <label className='m-0 d-flex flex-column' htmlFor={"1"}>
                                    Today
                                    <small>{toDateString(firstDate)}, {toTimeString(firstDate)} - {toTimeString(lastDate)}</small>
                                </label>
                            </div>
                        </div>

                        <div className="d-flex align-items-center">
                            <input checked={typeDateTime==="2"} id={"2"} onChange={()=>{
                                setTypeDateTime("2")
                                setStartDate("")
                                setEndDate("")
                            }} className='mr-2' name="type-date-time-selection-radio" key={"2"} value={"2"}
                                   type='radio'/>
                            <label className='m-0' htmlFor={"2"}>Specific date range</label>
                        </div>
                    </div>}
                </div>
            </div>
            {
                typeDateTime === "2"
                && 
                <>
                        <div className="row mb-3">
                            <div className="col-md-3 col-12 ">
                                <p className="font-weight-semi-bold  mt-1 mb-1">Date Range</p>
                            </div>
                            <div className="col-md-8 col-12 d-flex align-items-center">
                                <div className="form-group mb-0">
                                    <DateTimePickerWithCustomDisplay 
                                        customDisplayText="No start date"
                                        onChange={v => setStartDate(v)}
                                        value={toInputFieldDateTimeString(startDate)}
                                    />
                                </div>
                                <p className="m-0 mx-2">to</p>
                                <div className="form-group mb-0">
                                    <DateTimePickerWithCustomDisplay 
                                        customDisplayText="No end date"
                                        onChange={v => setEndDate(v)}
                                        value={toInputFieldDateTimeString(endDate)}
                                    />
                                </div>
                            </div>
                        </div> 
                    
                    <div className={ `row mt-3 ${ validOnlyOnSpecificDays ? "mb-3" : "" }` }>
                        <div className="col-md-3 col-12 ">
                            <p className="font-weight-semi-bold mb-1 ">Valid only on specific days</p>
                        </div>
                        <div className="col-md-6 col-12 custom-control custom-switch">
                            <input className="custom-control-input" type="checkbox" id="enable-any-day-week-switch" checked={ validOnlyOnSpecificDays } onChange={ e => {
                                setValidOnlyOnSpecificDays(!validOnlyOnSpecificDays)
                                if (!e.target.checked) {
                                    setValidOnlyOnSpecificDays(false)
                                    setIsValidMonday(false)
                                    setIsValidTuesday(false)
                                    setIsValidWednesday(false)
                                    setIsValidThursday(false)
                                    setIsValidFriday(false)
                                    setIsValidSaturday(false)
                                    setIsValidSunday(false)
                                }
                            } } />
                            <label className="custom-control-label ml-3" htmlFor="enable-any-day-week-switch"></label>
                            <p className="m-0 ml-3 mt-1">{ validOnlyOnSpecificDays ? <>Yes</> : <>No</> }</p>
                        </div>
                    </div>
                    <div className="mt-3">{
                        validOnlyOnSpecificDays &&
                        <>
                            <div className="row mb-3">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold  mt-1 mb-1">Monday</p>
                                </div>
                                <div className="col-md-6 col-12 custom-control custom-switch">
                                    <input className="custom-control-input" type="checkbox" id="enable-monday-switch" checked={ isValidMonday } onChange={ () => setIsValidMonday(prevState => !prevState) } />
                                    <label className="custom-control-label ml-3" htmlFor="enable-monday-switch"></label>
                                    <p className="m-0 ml-3 mt-1">{ isValidMonday ? <>Yes</> : <>No</> }</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold  mt-1 mb-1">Tuesday</p>
                                </div>
                                <div className="col-md-6 col-12 custom-control custom-switch">
                                    <input className="custom-control-input" type="checkbox" id="enable-tuesday-switch" checked={ isValidTuesday } onChange={ () => setIsValidTuesday(prevState => !prevState) } />
                                    <label className="custom-control-label ml-3" htmlFor="enable-tuesday-switch"></label>
                                    <p className="m-0 ml-3 mt-1">{ isValidTuesday ? <>Yes</> : <>No</> }</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold  mt-1 mb-1">Wednesday</p>
                                </div>
                                <div className="col-md-6 col-12 custom-control custom-switch">
                                    <input className="custom-control-input" type="checkbox" id="enable-wednesday-switch" checked={ isValidWednesday } onChange={ () => setIsValidWednesday(prevState => !prevState) } />
                                    <label className="custom-control-label ml-3" htmlFor="enable-wednesday-switch"></label>
                                    <p className="m-0 ml-3 mt-1">{ isValidWednesday ? <>Yes</> : <>No</> }</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold  mt-1 mb-1">Thursday</p>
                                </div>
                                <div className="col-md-6 col-12 custom-control custom-switch">
                                    <input className="custom-control-input" type="checkbox" id="enable-thursday-switch" checked={ isValidThursday } onChange={ () => setIsValidThursday(prevState => !prevState) } />
                                    <label className="custom-control-label ml-3" htmlFor="enable-thursday-switch"></label>
                                    <p className="m-0 ml-3 mt-1">{ isValidThursday ? <>Yes</> : <>No</> }</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold  mt-1 mb-1">Friday</p>
                                </div>
                                <div className="col-md-6 col-12 custom-control custom-switch">
                                    <input className="custom-control-input" type="checkbox" id="enable-friday-switch" checked={ isValidFriday } onChange={ () => setIsValidFriday(prevState => !prevState) } />
                                    <label className="custom-control-label ml-3" htmlFor="enable-friday-switch"></label>
                                    <p className="m-0 ml-3 mt-1">{ isValidFriday ? <>Yes</> : <>No</> }</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold  mt-1 mb-1">Saturday</p>
                                </div>
                                <div className="col-md-6 col-12 custom-control custom-switch">
                                    <input className="custom-control-input" type="checkbox" id="enable-saturday-switch" checked={ isValidSaturday } onChange={ () => setIsValidSaturday(prevState => !prevState) } />
                                    <label className="custom-control-label ml-3" htmlFor="enable-saturday-switch"></label>
                                    <p className="m-0 ml-3 mt-1">{ isValidSaturday ? <>Yes</> : <>No</> }</p>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold  mt-1 mb-1">Sunday</p>
                                </div>
                                <div className="col-md-6 col-12 custom-control custom-switch">
                                    <input className="custom-control-input" type="checkbox" id="enable-sunday-switch" checked={ isValidSunday } onChange={ () => setIsValidSunday(prevState => !prevState) } />
                                    <label className="custom-control-label ml-3" htmlFor="enable-sunday-switch"></label>
                                    <p className="m-0 ml-3 mt-1">{ isValidSunday ? <>Yes</> : <>No</> }</p>
                                </div>
                            </div>
                        </>
                    }</div>
                    <div className={ `row mt-3 ${ validOnlyAtSpecificTimes ? "mb-3" : "" }` }>
                        <div className="col-md-3 col-12 ">
                            <p className="font-weight-semi-bold mb-1 ">Valid only at specific times of the day</p>
                        </div>
                        <div className="col-md-6 col-12 custom-control custom-switch">
                            <input className="custom-control-input" type="checkbox" id="enable-any-time-day-switch" checked={ validOnlyAtSpecificTimes } onChange={ e => {
                                setValidOnlyAtSpecificTimes(!validOnlyAtSpecificTimes)
                                if (!e.target.checked) {
                                    setValidOnlyAtSpecificTimes(false)
                                    setEnabledFromTime("00:00:00")
                                    setEnabledToTime("23:59:59")
                                }
                            } } />
                            <label className="custom-control-label ml-3" htmlFor="enable-any-time-day-switch"></label>
                            <p className="m-0 ml-3 mt-1">{ validOnlyAtSpecificTimes ? <>Yes</> : <>No</> }</p>
                        </div>
                    </div>
                    {
                        validOnlyAtSpecificTimes &&
                        <div className="row mb-3">
                            <div className="col-md-3 col-12 ">
                                <p className="font-weight-semi-bold mb-1">Time Range</p>
                            </div>
                            <div className="col-md-6 col-12">
                                <TimeRangeSlider
                                    startTime={ enabledFromTime }
                                    endTime={ enabledToTime }
                                    onChange={ value => {
                                        setEnabledFromTime(value.startTime)
                                        setEnabledToTime(value.endTime)
                                    } }
                                />
                            </div>
                        </div>
                    }
                </>
            }

            
                <div className="row mt-3 mb-1">
                    <div className="col-md-3 col-12 ">
                        <p className="font-weight-semi-bold mb-1">Maximum Stay</p>
                    </div>
                    <div className="col-md-6 col-12 d-flex align-items-center">
                        <MinutesInputWithUnit
                                numberOfMinutes={ maxStayMinutes }
                                handleChange={ setMaxStayMinutes }
                            />
                        <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setMaxStayMinutes(null) }>
                            <i className="fas fa-undo mr-1"></i>
                            Clear
                        </button>
                    </div>
                </div>
            
                <div className="row mb-3">
                    <div className="col-md-3 col-12 ">
                        <p className="font-weight-semi-bold mb-1">No return within</p>
                    </div>
                    <div className="col-md-6 col-12 d-flex align-items-center">
                        <MinutesInputWithUnit
                                numberOfMinutes={ noReturnWithinMinutes }
                                handleChange={ setNoReturnWithinMinutes }
                            />
                        <button type="button" className="btn btn-sm btn-falcon-default d-flex align-items-center m-0 ml-2" onClick={ () => setNoReturnWithinMinutes(null) }>
                            <i className="fas fa-undo mr-1"></i>
                            Clear
                        </button>
                    </div>
                </div>
            
        </div>
    )
}